import React from 'react';

export default function Alerta({ mensaje, titulo = "Atención" }) {
    if (!mensaje) return "";
    return (
        <div class="alert alert-warning fade show">
            <b><i className="fa fa-circle-exclamation"></i>&nbsp;&nbsp;{mensaje}</b>
        </div>
    )
}